import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { isPhone } from '@helpers';

import TouchableElement from '@components/common/touchableElement';
import Loading from '@components/loading';

import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';

import Success from './pingResult/success';
import Error from './pingResult/error';
import { modalBg } from '@v2/pages/common/constants/base.constants';

export default (props) => {
  const { C, setMode, MODES, data, hide, goBack } = props;
  
  const renderStatusComponent = () => {
    if (data.error) {
      return <Error {...props} />;
    }

    if (data.success) {
      return <Success {...{ data, C }} />;
    }

    return (
      <View>
        <View style={{ marginTop: scale(20), paddingHorizontal: scale(15), justifyContent: 'center', alignItems: 'center' }}>
          <Loading {...{ background: C(modalBg), color: C('System/Light/Blue') }} />
        </View>
        <View style={{ marginTop: scale(14), paddingHorizontal: scale(15), justifyContent: 'center', alignItems: 'center' }}>
          <Text style={[{ color: C('Label/Light/Primary') }, font.Headline]}>{i18n.t('Connecting...')}</Text>
        </View>
        <View style={{ marginTop: scale(5), paddingHorizontal: scale(15), justifyContent: 'center', alignItems: 'center' }}>
          <Text style={[{ color: C('Label/Light/Tertiary') }, font.Footnote]}>
            {i18n.t('Trying to connect to')} {data.endpoint}
          </Text>
        </View>
      </View>
    );
  };

  return (
    <View style={{ paddingBottom: scale(20), paddingHorizontal: isPhone ? 0 : scale(15) }}>
      <View>
        <View
          style={{
            width: '100%',
            zIndex: 1000,
            height: scale(58),
          }}
        >
          <View style={{ position: 'absolute', zIndex: 1000, left: 0 }}>
            {!data.success && (
              <TouchableElement
                onPress={() => {
                  goBack();
                }}
              >
                {({ boxStyle, pressHoverColor }) => (
                  <View style={[boxStyle, { padding: scale(15), paddingHorizontal: isPhone ? scale(15) : 0, flexDirection: 'row' }]}>
                    <View style={{ marginTop: scale(2) }}>
                      <Svg icon="chevronLeft" width={scale(11)} height={scale(17)} color="Link / Light / Primary" />
                    </View>
                    <Text style={[{ color: C(pressHoverColor('System/Light/Blue')), marginLeft: scale(7) }, font.Body]}>{i18n.t('Back')}</Text>
                  </View>
                )}
              </TouchableElement>
            )}
          </View>
          {(data.success || data.error) && (
            <View style={{ position: 'absolute', zIndex: 1000, right: 0 }}>
              <TouchableElement
                onPress={() => {
                  if (data.error) {
                    return hide();
                  }
                  setMode(MODES.ADD_SHORT_NAME);
                }}
              >
                {({ boxStyle, pressHoverColor }) => (
                  <View style={[boxStyle, { padding: scale(15) }]}>
                    <Text style={[{ color: C(pressHoverColor('Link/Light/Primary')) }, font.Headline]}>{i18n.t(data.error ? 'Close' : 'Next')}</Text>
                  </View>
                )}
              </TouchableElement>
            </View>
          )}
        </View>
        <View style={{ width: '100%', position: 'absolute', zIndex: 100, top: scale(15) }}>
          <Text style={[{ color: C('Label/Light/Primary'), width: '100%', textAlign: 'center' }, font.Headline]}>
            {data.success || data.error ? '' : data.machineBrandName || data.connectionMethodName || i18n.t('Automatic')}
          </Text>
        </View>
      </View>
      {renderStatusComponent()}
    </View>
  );
};
